import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import {
  Box,
  Icon,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@saviynt/design-system';
import PropTypes from 'prop-types';

import AddToExport from '../../../../page/CertificationDetails/CertsExport/AddToExport';
import IncludedInExport from '../../../../page/CertificationDetails/CertsExport/IncludedInExport';
import { getMessageKey } from '../../../../utils/utils';
import { CAMP_TYPE_EO } from '../../CertsListTile/constant';

function SelectAndOrganizeYourData({
  selection,
  setSelection,
  showUsers,
  showRoles,
  showAccounts,
  showEntitlements,
  showChildEntitlements,
  allColumnsData,
  setAllColumnsData,
  selectedTab,
  campaignType,
}) {
  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user);

  const isEOCampaign = campaignType === CAMP_TYPE_EO;

  const title =
    messages.CERTS_EXPORT_SELECT_AND_ORGANIZE_YOUR_DATA ||
    localize(intl, getMessageKey('CERTS_EXPORT_SELECT_AND_ORGANIZE_YOUR_DATA'));
  const userLabel =
    messages['User_DISPLAYNAME.CERTIFICATIONS'] ||
    localize(intl, getMessageKey('User_DISPLAYNAME.CERTIFICATIONS'));
  const roleLabel =
    messages['Role_DISPLAYNAME.CERTIFICATIONS'] ||
    localize(intl, getMessageKey('Role_DISPLAYNAME.CERTIFICATIONS'));
  const accountLabel =
    messages['Account_DISPLAYNAME.CERTIFICATIONS'] ||
    localize(intl, getMessageKey('Account_DISPLAYNAME.CERTIFICATIONS'));
  const entitlementLabel =
    messages['Ent_DISPLAYNAME.CERTIFICATIONS'] ||
    localize(intl, getMessageKey('Ent_DISPLAYNAME.CERTIFICATIONS'));
  const childEntitlementLabel =
    messages['ChildEnt_DISPLAYNAME.CERTIFICATIONS'] ||
    localize(intl, getMessageKey('ChildEnt_DISPLAYNAME.CERTIFICATIONS'));

  return (
    <Box className='SelectAndOrganizeYourData'>
      <Typography kind='h3'>{title}</Typography>
      <Box className='SelectAndOrganizeYourData-tabs'>
        {isEOCampaign ? (
          <ToggleButtonGroup selection={selection} setSelection={setSelection}>
            {showEntitlements && (
              <ToggleButton
                label={entitlementLabel}
                icon={
                  <Icon
                    className='InputField-suffixButton-icon'
                    kind='Entitlement'
                    color='navy-700'
                    size='smallMedium'
                  />
                }
              />
            )}

            {showAccounts && (
              <ToggleButton
                label={accountLabel}
                icon={
                  <Icon
                    className='InputField-suffixButton-icon'
                    kind='Account'
                    color='navy-700'
                    size='smallMedium'
                  />
                }
              />
            )}

            {showChildEntitlements && (
              <ToggleButton
                label={childEntitlementLabel}
                icon={
                  <Icon
                    className='InputField-suffixButton-icon'
                    kind='Entitlement'
                    color='navy-700'
                    size='smallMedium'
                  />
                }
              />
            )}
          </ToggleButtonGroup>
        ) : (
          <ToggleButtonGroup selection={selection} setSelection={setSelection}>
            {showUsers && (
              <ToggleButton
                label={userLabel}
                icon={
                  <Icon
                    className='InputField-suffixButton-icon'
                    kind='UserBg'
                    size='smallMedium'
                  />
                }
              />
            )}
            {showAccounts && (
              <ToggleButton
                label={accountLabel}
                icon={
                  <Icon
                    className='InputField-suffixButton-icon'
                    kind='Account'
                    color='navy-700'
                    size='smallMedium'
                  />
                }
              />
            )}
            {showEntitlements && (
              <ToggleButton
                label={entitlementLabel}
                icon={
                  <Icon
                    className='InputField-suffixButton-icon'
                    kind='Entitlement'
                    color='navy-700'
                    size='smallMedium'
                  />
                }
              />
            )}
            {showRoles && (
              <ToggleButton
                label={roleLabel}
                icon={
                  <Icon
                    className='InputField-suffixButton-icon'
                    kind='Role'
                    color='navy-700'
                    size='smallMedium'
                  />
                }
              />
            )}
            {showChildEntitlements && (
              <ToggleButton
                label={childEntitlementLabel}
                icon={
                  <Icon
                    className='InputField-suffixButton-icon'
                    kind='Entitlement'
                    color='navy-700'
                    size='smallMedium'
                  />
                }
              />
            )}
          </ToggleButtonGroup>
        )}
      </Box>
      <Box className='SelectAndOrganizeYourData-tabsContent'>
        <IncludedInExport
          allColumnsData={allColumnsData}
          setAllColumnsData={setAllColumnsData}
          selectedTab={selectedTab}
        />
        <AddToExport
          allColumnsData={allColumnsData}
          setAllColumnsData={setAllColumnsData}
          selectedTab={selectedTab}
        />
      </Box>
    </Box>
  );
}

SelectAndOrganizeYourData.propTypes = {
  selection: PropTypes.string.isRequired,
  setSelection: PropTypes.func.isRequired,
  showUsers: PropTypes.bool,
  showRoles: PropTypes.bool,
  showAccounts: PropTypes.bool,
  showEntitlements: PropTypes.bool,
  allColumnsData: PropTypes.arrayOf({}).isRequired,
  setAllColumnsData: PropTypes.func.isRequired,
  selectedTab: PropTypes.string.isRequired,
  campaignType: PropTypes.string.isRequired,
};

SelectAndOrganizeYourData.defaultProps = {
  showUsers: false,
  showRoles: false,
  showAccounts: false,
  showEntitlements: false,
};

export default SelectAndOrganizeYourData;
